import { token } from '@atlaskit/tokens';
import { Tokens } from '@atlassian/jira-custom-theme-constants/src/constants.tsx';
import type { ProjectPagesTheme } from '@atlassian/jira-project-pages/src/view/types.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';

// why => confluence takes more attributes then in the ProjectPagesTheme type
// Theme is passed here platform/packages/confluence/project-pages/src/index.tsx L:225
type ProjectPagesThemeInJira = ProjectPagesTheme & {
	overrideStyles: {
		contentWrapper: {
			padding: string;
		};
		sidebarWrapper: {
			backgroundColor: string;
			border: string;
			borderRadius: string;
			boxShadow: string;
			height: string;
			margin: string;
			padding: string;
		};
		viewContainer: {
			padding: string;
		};
	};
};

export const pagesOverrideStyles = ({
	name,
	type,
}: {
	name: string;
	type: string;
}): ProjectPagesThemeInJira => ({
	name,
	type,
	background: { color: 'inherit' },
	color: { primary: Tokens.COLOR_TEXT },
	navigation: {
		icon: {
			textColor: Tokens.COLOR_TEXT,
			color: Tokens.COLOR_TEXT,
			gradientStart: Tokens.COLOR_TEXT,
			gradientStop: Tokens.COLOR_TEXT_SUBTLE,
		},
	},
	overrideStyles: {
		mainContainer: {
			backgroundColor: token('elevation.surface'),
			color: token('color.text'),
			borderRadius: '8px',
			padding: token('space.150'),
		},
		pageHeader: {
			wrapper: {
				backgroundColor: Tokens.ELEVATION_SURFACE_CONTRAST,
				padding: `0 ${token('space.200')}`,
				margin: `${token('space.300')} 0 ${token('space.150')} 0`,
				borderRadius: token('border.radius.200'),
			},
		},
		pageTitleStyleWrapper: {
			color: Tokens.COLOR_TEXT,
			// The API expects a number here
			marginTop: 2,
			outline: 'none',
			font: token('font.heading.large'),
		},
		tableTreeWrapper: {
			borderRadius: token('border.radius.200'),
		},
		poweredBy: {
			color: Tokens.COLOR_TEXT,
		},
		contentWrapper: {
			padding: '0',
		},
		sidebarWrapper: {
			backgroundColor: token('elevation.surface'),
			border: 'none',
			borderRadius: `${
				// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "6px" do not match and can't be replaced automatically.
				token('border.radius.100', '6px')
			} ${token('border.radius.200')} 0 0`,
			boxShadow: token('elevation.shadow.overlay'),
			height: 'auto',
			margin: `${isVisualRefreshEnabled() ? `${token('space.250')} 0 0` : `${token('space.200')} 0 0`} `,
			padding: `${token('space.100')} ${token('space.250')}`,
		},
		viewContainer: {
			padding: '0',
		},
	},
});
